var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"content",staticClass:"content"},[(!_vm.navHidden)?_c('van-nav-bar',{attrs:{"title":_vm.title,"left-arrow":""},on:{"click-left":_vm.goBack}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }